import { apiConstants } from "../../utils/apiConstants";
import { apiTypes } from "../../utils/apiTypes";
import apiRequestType from "../apiRequestType";

const addTrainingType = (data) => {
  return apiRequestType(
    apiTypes.POST,
    apiConstants.MANAGE.ADD_TRAINING_TYPES,
    data
  );
};

export default addTrainingType;
